import React from 'react';
import { compose, withProps, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { withTranslation, Trans } from 'react-i18next';

import { actions as uiActions } from 'state/ui';
import { selectors as settingsSelectors } from 'state/settings';
import { actions as paymentDataActions } from 'state/paymentData';
import Link from 'components/styled/link';

import PaymentDataModal from 'components/orders/PaymentDataModal/component';

const getPropsByType = {
  denied: (t) => ({
    img: '/payment-method-problem.png',
    title: t('Modals.denied.title'),
    info: t('Modals.denied.info'),
    closeLabel: t('Modals.denied.closeLabel'),
    closeStyle: 'secondary',
    submitLabel: t('Modals.denied.submitLabel'),
  }),
  pending: (t, { financeEmail, financePhone }) => ({
    img: '/payment-scan.png',
    title: t('Modals.pending.title'),
    info: (
      <Trans
        t={t}
        i18nKey="Modals.pending.info"
        values={{ finance_email: financeEmail, finance_phone: financePhone }}
        components={[
          <Link
            href={`mailto:${financeEmail}`}
            text={financeEmail}
            noTextDecoration
            target="_blank"
          />,
          <span>{financePhone}</span>,
        ]}
      />
    ),
    closeLabel: t('Modals.pending.closeLabel'),
  }),
};

const enhance = compose(
  withTranslation('PaymentData'),
  connect(
    (state) => ({
      financeEmail: settingsSelectors.getFinanceEmail(state),
      financePhone: settingsSelectors.getFinancePhone(state),
    }),
    {
      handleCloseDenied: uiActions.togglePaymentDataDeniedModalOpened,
      handleClosePending: uiActions.togglePaymentDataPendingModalOpened,
      handleChangeToCreditCard: paymentDataActions.changeToCreditCard,
    }
  ),
  withProps(({ t, type, financeEmail, financePhone }) => ({
    ...getPropsByType[type](t, { financeEmail, financePhone }),
  })),
  withHandlers({
    handleClose:
      ({ type, handleCloseDenied, handleClosePending }) =>
      () => {
        if (type === 'denied') handleCloseDenied();
        if (type === 'pending') handleClosePending();
      },
    handleSubmit:
      ({ type, handleChangeToCreditCard }) =>
      () => {
        if (type === 'denied') {
          handleChangeToCreditCard();
        }
      },
  })
);

export default enhance(PaymentDataModal);
